(function(){
	if (typeof APPS === "undefined"){ APPS = {}}
	APPS.competitions = {};
	console.log("APP compe")
	
	var Router = Marionette.AppRouter.extend({
		appRoutes: {
			"competitions": "competitions"
		}
	})
	
	var API = {
		competitions: function(){
			APPS.competitions.page.show();
		}
	}
	
	APP.on("before:start", function(){
		new Router({ controller: API }) 
	})
})();

